import React, { Component } from 'react'
import styled from 'styled-components'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router'
import { push } from 'react-router-redux'
import moment from 'moment'
import queryString from 'query-string'
import { Table, TableCell, TableHeader, TableLoading, Button, RoundedTabs, Modal, Pagination } from 'advenio-components'
import ReservedEnrollmentsActions from '../../Data/Redux/ReservedEnrollmentsRedux'
import ReinscriptionModal from './ReinscriptionModal'
import EnrollActions from '../../Data/Redux/EnrollRedux'
import AllCentersActions from '../../Data/Redux/AllCentersRedux'
import ClassroomActions from '../../Data/Redux/ClassroomRedux'
import DeleteStudentModal from './DeleteStudentModal'
import StudyProgramsActions from '../../Data/Redux/StudyProgramsRedux'
import CenterProductsActions from '../../Data/Redux/CenterProductsRedux'

const Container = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: flex-start;
`
const TableContainer = styled.div`
  width: 100%;
  margin-top: 30px;
  padding-left: 24px;
  padding-right: 24px;
`
const PaginationContainer = styled.div`
  margin: 12px 0;
`
const CellContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color:#FFFFFF;
  height: 100%;
`
const Center = styled.span`
  padding: 10px 30px 10px 30px;
  background-color: #9B9B9B;
  border-radius: 20px;
  color: #FFF;
`
const InfoContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 80%;
  height: 100%;
`
const PhotoContainer = styled.div`
  width: 30%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`
const NameContainer = styled.div`
  width: 70%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
`
const Photo = styled.div`
  background-image: ${props => props.profile_image ? `url( ${props.profile_image} )` : ''};
  background-size: cover;
  background-position: center;
  width: 40px;
  height: 40px;
  border-radius: 10%;
  border:  solid #CCCCCC 1px;
`
const HeaderContainer = styled.div`
  width: 100%;
  height: 60px;
  margin-bottom: 30px;
  display: flex;
  flex-direction: row;
  align-items: center;
`
const ProfileDiv = styled.div`
  position: absolute;
  z-index: 10;
  display: flex;
  flex: 1;
  height: 10%;
  width: 63%;
  cursor: ${props => props.classroom ? 'pointer':''};
`
const ProfileDivOverlay = styled.div`
position: absolute;
display: flex;
justify-content: center;
align-items: center;
height: 100px;
width: 70px;
cursor: pointer;
`
const ButtonText = styled.span`
  padding: 15px 40px 15px 30px;
`

class Reservations extends Component {
  constructor(props) {
    super(props)
    this.state = {
      activeId: null,
      isOpened: false,
      deleteStudent: false,
      parents: null,
      firstPageToRender: 1,
      lastPageToRender: 10,
      pageSelected: 1,
      queryParams: {},
      center: null,
      activeChild:null
    }
  }

  componentWillMount() {
    const queryParams = queryString.parse(this.props.location.search)
    if (queryParams.page) {
      this.setState({ pageSelected: Number(queryParams.page) })
    }
    this.setState({ queryParams })
    this.props.getReservedEnrollments(queryParams)
    this.props.getClassrooms({'basic':true,'students':false})
    this.props.getStudyPrograms(this.props.user.center_id)
    this.props.getCenterProducts(this.props.user.center_id)
    this.props.getAllCenters()
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.centers) {
      const selectedCenter = nextProps.centers.find(c => c.id === nextProps.user.center_id)
      this.setState({ center: selectedCenter })
    }
  }
  viewProfile = (profileId,classroom) =>{
    this.props.setActiveStudentId(Number(profileId))
    this.props.setActiveClassroomId(Number(classroom))
    if(classroom){
      this.props.history.push(`classroom/${classroom}/student/${profileId}`)
    }
  }
  onClickPage = (page) => {
    this.setState({ pageSelected: page }, () => {
      const { queryParams } = this.state
      const { getReservedEnrollments, goTo, match } = this.props

      const queries = { ...queryParams, page }
      getReservedEnrollments(queries)
      goTo(`?${queryString.stringify(queries)}`)
    })
  }

  onClick = (e) => {
    const [selectedChild] = this.props.reserved_enrollments.filter(child => child.id == e.target.id)
    this.setState({ activeId: e.target.id, isOpened: true, parents: selectedChild.parents })
  }

  onClose = () => {
    this.setState({ isOpened: false, deleteStudent: false })
  }

  getChildInfo = (id,name, paternalLastname, maternalLastname, parent, image, classroom) => {
    let profile = ''
    const childName = name || ''
    const childMaternalLastName = maternalLastname || ''
    const childPaternalLastName = paternalLastname || ''
    if (image === '') {
      profile = '/assets/BabyAvatar.svg'
    } else {
      profile = image
    }
    return (
      <InfoContainer>
        <PhotoContainer>
          <Photo profile_image={profile} />
        </PhotoContainer>
        <NameContainer>
        <ProfileDiv classroom={classroom} onClick={(e)=>{this.viewProfile(id,classroom)}} />
          <span style={{ marginBottom: '2px' }}>{`${childName} ${childPaternalLastName} ${childMaternalLastName}`}</span>
          <span style={{ color: '#4A4A4A' }}>{`Tutor: ${parent[0].full_name}`}</span>
        </NameContainer>
      </InfoContainer>
    )
  }

  getCompanyParent = parent => {
    const { companies } = this.props
    const [companySelected] = companies.filter(company => company.id === parent.company_id)

    return (
      <InfoContainer>
        <NameContainer>
          <span style={{ marginBottom: '2px', textOverflow: 'ellipsis' }}>{`${companySelected ? companySelected.name :'Sin Empresa'} `}</span>
          {/* <span style={{ color: '#4A4A4A' }}>{`Tutor:  ${parent.length>0 ? parent[0].full_name:''}`}</span> */}
        </NameContainer>
      </InfoContainer>
    )
  }

  goTo = (e) => {
    this.props.goTo(e.currentTarget.id)
  }

  openDeleteStudent = (e) => {
    const [selectedChild] = this.props.reserved_enrollments.filter(child => child.id == e.target.id)
    this.setState({ activeId: e.target.id, deleteStudent: true ,
      activeChild: `${selectedChild.first_name} ${selectedChild.last_name_paternal}`})
  }

  deleteStudent = (id, comment) => {
    const params = {
      comments: comment,
    }
    this.props.deleteEnroll(id, params)
  }

  render() {
    const { centerProducts, studyPrograms, classrooms, meta } = this.props
    const { pageSelected, center ,activeChild} = this.state
    return (
      <Container>
        <TableContainer>
          <HeaderContainer>
            <RoundedTabs
              selectedTab={'/reservations'}
              tabs={[
                {
                  id: '/enrollments',
                  title: 'Inscripciones',
                },
                {
                  id: '/reinscriptions',
                  title: 'Reinscripciones',
                },
                {
                  id: '/reservations',
                  title: 'Reservaciones',
                },
                {
                  id: '/disenrollments',
                  title: 'Bajas',
                },
              ]}
              onClick={this.goTo}
            />
          </HeaderContainer>
          <PaginationContainer>
            <Pagination
              totalElements={meta && meta.total}
              elementsPerPage={meta && meta.per_page}
              onPageClick={this.onClickPage}
              pageSelected={pageSelected}
            />
          </PaginationContainer>
          {this.props.loading ?
            <TableLoading
              roundedCorners
              columns={[
                {
                  id: 1,
                  header: 'Alumno y Tutor',
                  element: 'Text',
                  center: true,
                },
                {
                  id: 2,
                  header: 'Mes de reservación',
                  element: 'Text',
                  center: true,
                },
                {
                  id: 3,
                  header: '¿Quién Atendió?',
                  element: 'Text',
                  center: true,
                },
                {
                  id: 4,
                  header: 'Empresa',
                  element: 'Text',
                  center: true,
                },
                {
                  id: 5,
                  header: 'Acciones',
                  element: 'Text',
                  center: true,
                }
              ]}
              rows={10}
            />
            :
            <Table
              data={this.props.reserved_enrollments}
              columns={[
                {
                  id: '1',
                  Header: () => <TableHeader title="Alumno y Tutor" center blue />,
                  accessor: ({id, first_name, parents, last_name_paternal, last_name_maternal, classroom_id }) =>
                    ({id, first_name, parents, last_name_paternal, last_name_maternal, classroom_id }),
                  Cell: ({
                    value: {id, first_name, parents, last_name_paternal, last_name_maternal, classroom_id } }) =>
                    <CellContainer>{this.getChildInfo(id,first_name, last_name_paternal, last_name_maternal, parents, '',classroom_id)}</CellContainer>,
                },
                {
                  id: '2',
                  Header: () => <TableHeader title="Mes de reservación" center blue />,
                  accessor: ({ reservation_date }) => ({ reservation_date }),
                  Cell: ({ value: { reservation_date } }) =>
                    <CellContainer>{ reservation_date ?  moment(reservation_date).format('MMMM YYYY'): ''}</CellContainer>,
                  maxWidth: 200,
                },
                {
                  id: '3',
                  Header: () => <TableHeader title="¿Quién Atendió?" center blue />,
                  accessor: ({ assigned_to }) => ({ assigned_to }),
                  Cell: ({ value: { assigned_to } }) =>
                    <CellContainer><span>{assigned_to}</span></CellContainer>,
                },
                {
                  id: '4',
                  Header: () => <TableHeader title="Empresa" center blue />,
                  accessor: ({ parents }) => ({ parents }),
                  Cell: ({ value: { parents } }) =>
                    <CellContainer>{this.getCompanyParent(parents[0])}</CellContainer>,
                },
                {
                  id: '5',
                  Header: () => <TableHeader title="Acciones" center blue />,
                  accessor: ({ first_name, id, last_name_paternal, last_name_maternal }) =>
                    ({ first_name, id, last_name_paternal, last_name_maternal }),
                  Cell: ({ value: { id } }) => 
                  <TableCell center>
                    <Button success small id={id} onClick={this.onClick}>
                      <span style={{ padding: '0px 5px' }}  id={id} >Inscribir</span>
                    </Button>
                    <Button danger small id={id} onClick={this.openDeleteStudent} >
                      <span style={{ padding: '0px 5px' }}  id={id} >Borrar</span>
                    </Button>
                  </TableCell>,
                }]}
            />
          }
        </TableContainer>
        <Modal
          isOpened={this.state.isOpened &&
            centerProducts.length > 0 && studyPrograms.length > 0 && classrooms.length > 0}
          onClose={this.onClose}
          headerTitle="Inscribir Alumno"
          statePath="reserved"
          actionType="sending"
          typePrefix="RESERVED"
        >
          <ReinscriptionModal
            id={this.state.activeId}
            classrooms={this.props.classrooms}
            studyPrograms={this.props.studyPrograms}
            parents={this.state.parents}
            type="reserved"
            products={this.props.centerProducts}
            closeModal={this.onClose}
            needsCurp={center && center.requires_tax_id}
          />
        </Modal>
        <Modal
          isOpened={this.state.deleteStudent}
          onClose={this.onClose}
          headerTitle="Eliminar Alumno"
          statePath="enroll"
          actionType="sending"
          typePrefix="ENROLL"
        >
          <DeleteStudentModal
            closeModal={this.onClose}
            delete={this.deleteStudent}
            activeId={this.state.activeId}
            student={activeChild}
          />
        </Modal>
      </Container>
    )
  }
}

Reservations.propTypes = {
  loading: PropTypes.bool.isRequired,
  classrooms: PropTypes.array.isRequired,
  getClassrooms: PropTypes.func.isRequired,
  goTo: PropTypes.func.isRequired,
  deleteEnroll: PropTypes.func.isRequired,
  getStudyPrograms: PropTypes.func.isRequired,
  getCenterProducts: PropTypes.func.isRequired,
  getReservedEnrollments: PropTypes.func.isRequired,
  user: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.object,
  ]),
  centerProducts: PropTypes.array.isRequired,
  studyPrograms: PropTypes.array.isRequired,
  reserved_enrollments: PropTypes.array,
  meta: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.object,
  ]),
  location: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.object,
  ]),
}

Reservations.defaultProps = {
  reserved_enrollments: [],
  meta: () => {},
  location: {},
  user: {},
}

const mapStateToProps = state => ({
  reserved_enrollments: state.reserved_enrollments.get.results.data,
  meta: state.reserved_enrollments.get.results.meta,
  links: state.reserved_enrollments.get.results.links,
  loading: state.reserved_enrollments.get.fetching,
  classrooms: state.classrooms.get.results,
  user: state.auth.user,
  studyPrograms: state.study_programs.get.results,
  centerProducts: state.center_products.get.results,
  centers: state.allCenters.get.results,
  companies: state.companies.get.results
})

const mapDispatchToProps = dispatch => ({
  getReservedEnrollments: query => dispatch(ReservedEnrollmentsActions.getRequest(query)),
  getAllCenters: () => dispatch(AllCentersActions.getRequest({},true)),
  goTo: path => dispatch(push(path)),
  getClassrooms: (query) => dispatch(ClassroomActions.getRequest(query,true)),
  setActiveStudentId: id => dispatch(ClassroomActions.setActiveStudentId(id)),
  setActiveClassroomId: id => dispatch(ClassroomActions.setActiveClassroomId(id)),
  deleteEnroll: (studentId, data) => dispatch(EnrollActions.deleteEnrollRequest(studentId, data)),
  getStudyPrograms: centerId => dispatch(StudyProgramsActions.getRequest(centerId)),
  getCenterProducts: centerId => dispatch(CenterProductsActions.getRequest(centerId)),
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Reservations))



// WEBPACK FOOTER //
// ./src/Containers/Inscriptions/Reservations.jsx